import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  // eslint-disable-next-line
  override handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk [\w-]+ failed/;

    if (chunkFailedMessage.test(error.message)) {
      window.location.reload();
    }

    super.handleError(error);
  }
}
